import { render, staticRenderFns } from "./BedMesh.vue?vue&type=template&id=f223c83e&"
import script from "./BedMesh.vue?vue&type=script&lang=ts&"
export * from "./BedMesh.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports